var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select-product ml-auto mr-auto"},[_c('v-container',{staticClass:"select-product__container py-0"},[(_vm.$route.params.id && _vm.$route.name === 'render-configurator')?_c('project-configurator'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }